import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { AngularFireAuth } from '@angular/fire/auth';
import firebase from 'firebase/app';
import 'firebase/auth';
import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

declare var google: any;
declare var gapi: any;

@Injectable({
  providedIn: 'root',
})
export class IaFilesService {
  private developerKey = 'AIzaSyDgaTiicU9J0xk2rwjJowM4GkQiqMTtCvs';
  private clientId =
    '5270040003-t16a7mpaa8fgbs5hr8eqobjip84pf3ar.apps.googleusercontent.com';
  private pickerApiLoaded = false;
  private oauthToken: string = '';
  private apiUrl = 'https://api.openai.com/v1/chat/completions';
  constructor(
    private firestore: AngularFirestore,
    private storage: AngularFireStorage,
    private afAuth: AngularFireAuth,
    private http: HttpClient
  ) {
    // Cargar Picker API
    gapi.load('picker', { callback: this.onPickerApiLoad.bind(this) });
  }

  onPickerApiLoad() {
    this.pickerApiLoaded = true;
  }
  getResponse(messages: { role: string; content: string }[]): Observable<any> {
    const payload = {
      model: 'gpt-4o-mini',
      messages,
      max_tokens: 1200,
      temperature: 0.7,
    };

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post(
      'https://us-central1-colegia-education-demo.cloudfunctions.net/app/callOpenAI',
      payload,
      { headers }
    );
  }

  private downloadFileFromGoogleDrive(fileId: string): Promise<Blob> {
    const url = `https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`;
    return fetch(url, {
      headers: {
        Authorization: 'Bearer ' + this.oauthToken,
      },
    }).then((response) => {
      if (!response.ok) throw new Error('Error al descargar el archivo.');
      return response.blob();
    });
  }

  openGooglePickerAndUpload(clase: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const createPicker = (token: string) => {
        const view = new google.picker.DocsView(google.picker.ViewId.DOCS)
          .setIncludeFolders(true)
          .setMimeTypes(
            'application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,application/vnd.openxmlformats-officedocument.presentationml.presentation'
          );

        const picker = new google.picker.PickerBuilder()
          .setDeveloperKey(this.developerKey)
          .setOAuthToken(token)
          .addView(view)
          .setCallback((data: any) => {
            if (data.action === google.picker.Action.PICKED) {
              const doc = data.docs[0];
              this.downloadFileFromGoogleDrive(doc.id)
                .then((blob: Blob) => {
                  const extension = doc.name.split('.').pop()?.toLowerCase();
                  const sanitizedFileName = doc.name
                    .replace(/\s/g, '')
                    .replace(/[^a-zA-Z0-9-.]/g, '');
                  const filePath = `drive/${clase}/${Date.now()}_${sanitizedFileName}`;
                  const fileRef = this.storage.ref(filePath);

                  this.storage
                    .upload(filePath, blob)
                    .then(() => {
                      fileRef
                        .getDownloadURL()
                        .subscribe((downloadURL: string) => {
                          resolve({
                            id: doc.id,
                            name: doc.name,
                            url: downloadURL,
                            mimeType: doc.mimeType,
                            extension: extension,
                          });
                        });
                    })
                    .catch((error) => reject(error));
                })
                .catch((error) => reject(error));
            } else if (data.action === google.picker.Action.CANCEL) {
              reject('El usuario canceló la selección');
            }
          })
          .build();

        picker.setVisible(true);
      };

      const provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('https://www.googleapis.com/auth/drive.readonly');

      firebase
        .auth()
        .signInWithPopup(provider)
        .then((result) => {
          const token = (result.credential as firebase.auth.OAuthCredential)
            ?.accessToken;
          if (!token) return reject('No se pudo obtener token');
          this.oauthToken = token;
          createPicker(token);
        })
        .catch((error) => {
          console.error('Error con Firebase Google Sign-In:', error);
          reject(error);
        });
    });
  }

  openOneDrivePicker(clase: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const odOptions = {
        clientId: 'c1e4524f-2ba8-4db0-8d24-573af10a4bbb',
        action: 'download',
        multiSelect: false,
        openInNewWindow: true,
        advanced: {
          redirectUri: window.location.origin,
          filter: '.pdf,.docx,.pptx,.txt',
        },
        success: async (files: any) => {
          const file = files.value[0];
          try {
            const response = await fetch(file['@microsoft.graph.downloadUrl']);
            const blob = await response.blob();
            const extension = file.name.split('.').pop()?.toLowerCase();
            const sanitizedFileName = file.name
              .replace(/\s/g, '')
              .replace(/[^a-zA-Z0-9-.]/g, '');
            const filePath = `onedrive/${clase}/${Date.now()}_${sanitizedFileName}`;
            const fileRef = this.storage.ref(filePath);

            await this.storage.upload(filePath, blob);
            const downloadURL = await fileRef.getDownloadURL().toPromise();

            resolve({
              id: file.id,
              name: file.name,
              url: downloadURL,
              mimeType: file.file.mimeType,
              extension: extension,
            });
          } catch (error) {
            reject(error);
          }
        },
        cancel: () => {
          reject('El usuario canceló la selección desde OneDrive');
        },
        error: (e: any) => {
          reject(e);
        },
      };

      if ((window as any).OneDrive) {
        (window as any).OneDrive.open(odOptions);
      } else {
        reject('OneDrive Picker no está disponible');
      }
    });
  }

  getMessages(chatid: string) {
    return this.firestore
      .collection('chatsFilesIa')
      .doc(chatid)
      .collection('messages', (ref) => ref.orderBy('fecha', 'asc'))
      .snapshotChanges(['added']);
  }

  sendmessage(id: string, message: any) {
    return this.firestore
      .collection('chatsFilesIa')
      .doc(id)
      .collection('messages')
      .add(message);
  }

  listFiles(folderPath: string): Promise<any[]> {
    const folderRef = this.storage.ref(folderPath);
    return folderRef
      .listAll()
      .toPromise()
      .then((result) => {
        const promises = result.items.map((itemRef) =>
          itemRef.getDownloadURL()
        );
        return Promise.all(promises).then((urls) => {
          return urls.map((url, index) => ({
            name: result.items[index].name,
            url: url,
          }));
        });
      });
  }
}
